/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesFetchAnalytics } from "../../funcs/workspacesFetchAnalytics.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdAnalyticsRequest$inboundSchema,
};

export const tool$workspacesFetchAnalytics: ToolDefinition<typeof args> = {
  name: "workspaces_fetch-analytics",
  description: `Get workspace analytics

Retrieves analytics data for a specific workspace`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesFetchAnalytics(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
